module.exports = __webpack_public_path__ + "static/media/synth_18.9e4a6533.mp3";